import {
  GET_FOLDERS,
  GET_FOLDERS_SUCCESS,
  GET_FOLDERS_FAIL,
  GET_FOLDERS_RESET,
  CREATE_FOLDER,
  CREATE_FOLDER_SUCCESS,
  CREATE_FOLDER_FAIL,
  CREATE_FOLDER_RESET,
  RENAME_FOLDER,
  RENAME_FOLDER_SUCCESS,
  RENAME_FOLDER_FAIL,
  RENAME_FOLDER_RESET,
  DELETE_FOLDER,
  DELETE_FOLDER_SUCCESS,
  DELETE_FOLDER_FAIL,
  DELETE_FOLDER_RESET,
  ADD_ITEM_TO_FOLDER,
  ADD_ITEM_TO_FOLDER_SUCCESS,
  ADD_ITEM_TO_FOLDER_FAIL,
  ADD_ITEM_TO_FOLDER_RESET,
  REMOVE_ITEM_FROM_FOLDER,
  REMOVE_ITEM_FROM_FOLDER_SUCCESS,
  REMOVE_ITEM_FROM_FOLDER_FAIL,
  REMOVE_ITEM_FROM_FOLDER_RESET,
  MOVE_FOLDER,
  MOVE_FOLDER_SUCCESS,
  MOVE_FOLDER_FAIL,
  MOVE_FOLDER_RESET,
  GET_FOLDER_BREADCRUMBS,
  GET_FOLDER_BREADCRUMBS_SUCCESS,
  GET_FOLDER_BREADCRUMBS_FAIL,
  GET_FOLDER_BREADCRUMBS_RESET,
} from '../actions/folderAction';

const initialState = {
  getFoldersState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  createFolderState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  renameFolderState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  deleteFolderState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  addItemToFolderState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  removeItemFromFolderState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  moveFolderState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
  getFolderBreadcrumbsState: {
    apiState: 'idle',
    data: null,
    message: null,
    errors: null,
    error: null,
  },
};

const folderReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get Folders
    case GET_FOLDERS:
      return {
        ...state,
        getFoldersState: { ...state.getFoldersState, apiState: 'loading' },
      };
    case GET_FOLDERS_SUCCESS:
      return {
        ...state,
        getFoldersState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Folders retrieved successfully',
          errors: action.response.errors || null,
        },
      };
    case GET_FOLDERS_FAIL:
      return {
        ...state,
        getFoldersState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to fetch folders',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case GET_FOLDERS_RESET:
      return { ...state, getFoldersState: initialState.getFoldersState };

    // Create Folder
    case CREATE_FOLDER:
      return {
        ...state,
        createFolderState: { ...state.createFolderState, apiState: 'loading' },
      };
    case CREATE_FOLDER_SUCCESS:
      return {
        ...state,
        createFolderState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Folder created successfully',
          errors: action.response.errors || null,
        },
      };
    case CREATE_FOLDER_FAIL:
      return {
        ...state,
        createFolderState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to create folder',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case CREATE_FOLDER_RESET:
      return { ...state, createFolderState: initialState.createFolderState };

    // Rename Folder
    case RENAME_FOLDER:
      return {
        ...state,
        renameFolderState: { ...state.renameFolderState, apiState: 'loading' },
      };
    case RENAME_FOLDER_SUCCESS:
      return {
        ...state,
        renameFolderState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Folder renamed successfully',
          errors: action.response.errors || null,
        },
      };
    case RENAME_FOLDER_FAIL:
      return {
        ...state,
        renameFolderState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to rename folder',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case RENAME_FOLDER_RESET:
      return { ...state, renameFolderState: initialState.renameFolderState };

    // Delete Folder
    case DELETE_FOLDER:
      return {
        ...state,
        deleteFolderState: { ...state.deleteFolderState, apiState: 'loading' },
      };
    case DELETE_FOLDER_SUCCESS:
      return {
        ...state,
        deleteFolderState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Folder deleted successfully',
          errors: action.response.errors || null,
        },
      };
    case DELETE_FOLDER_FAIL:
      return {
        ...state,
        deleteFolderState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to delete folder',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case DELETE_FOLDER_RESET:
      return { ...state, deleteFolderState: initialState.deleteFolderState };

    // Add Item to Folder
    case ADD_ITEM_TO_FOLDER:
      return {
        ...state,
        addItemToFolderState: { ...state.addItemToFolderState, apiState: 'loading' },
      };
    case ADD_ITEM_TO_FOLDER_SUCCESS:
      return {
        ...state,
        addItemToFolderState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Item added to folder successfully',
          errors: action.response.errors || null,
        },
      };
    case ADD_ITEM_TO_FOLDER_FAIL:
      return {
        ...state,
        addItemToFolderState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to add item to folder',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case ADD_ITEM_TO_FOLDER_RESET:
      return { ...state, addItemToFolderState: initialState.addItemToFolderState };

    // Remove Item from Folder
    case REMOVE_ITEM_FROM_FOLDER:
      return {
        ...state,
        removeItemFromFolderState: { ...state.removeItemFromFolderState, apiState: 'loading' },
      };
    case REMOVE_ITEM_FROM_FOLDER_SUCCESS:
      return {
        ...state,
        removeItemFromFolderState: {
          apiState: 'success',
          data: action.response,
          message: action.response.message || 'Item removed from folder successfully',
          errors: action.response.errors || null,
        },
      };
    case REMOVE_ITEM_FROM_FOLDER_FAIL:
      return {
        ...state,
        removeItemFromFolderState: {
          apiState: 'error',
          data: null,
          message: action.response?.message || action.response || 'Failed to remove item from folder',
          errors: action.response?.errors || null,
          error: action.response,
        },
      };
    case REMOVE_ITEM_FROM_FOLDER_RESET:
      return { ...state, removeItemFromFolderState: initialState.removeItemFromFolderState };

    // Move Folder
    case MOVE_FOLDER:
      return { ...state, moveFolderState: { ...state.moveFolderState, apiState: 'loading' } };
    case MOVE_FOLDER_SUCCESS:
      return { ...state, moveFolderState: { apiState: 'success', data: action.response, message: action.response.message || 'Folder moved successfully', errors: null } };
    case MOVE_FOLDER_FAIL:
      return { ...state, moveFolderState: { apiState: 'error', data: null, message: action.response?.message || action.response || 'Failed to move folder', errors: action.response?.errors || null, error: action.response } };
    case MOVE_FOLDER_RESET:
      return { ...state, moveFolderState: initialState.moveFolderState };

    // Get Folder Breadcrumbs
    case GET_FOLDER_BREADCRUMBS:
      return { ...state, getFolderBreadcrumbsState: { ...state.getFolderBreadcrumbsState, apiState: 'loading' } };
    case GET_FOLDER_BREADCRUMBS_SUCCESS:
      return { ...state, getFolderBreadcrumbsState: { apiState: 'success', data: action.response, message: 'Breadcrumbs retrieved', errors: null } };
    case GET_FOLDER_BREADCRUMBS_FAIL:
      return { ...state, getFolderBreadcrumbsState: { apiState: 'error', data: null, message: action.response?.message || 'Failed to get breadcrumbs', errors: null, error: action.response } };
    case GET_FOLDER_BREADCRUMBS_RESET:
      return { ...state, getFolderBreadcrumbsState: initialState.getFolderBreadcrumbsState };

    default:
      return state;
  }
};

export default folderReducer;
